import React, { Component } from "react";
import { connect } from "react-redux";

import {
  PROJECT_LOGIN,
  LOGIN,
  PROJECT_LOGIN_HOME,
  LOGIN_HOME
} from "App/Routes";
import GenericErrorPage from "components/ErrorPages/GenericError/GenericErrorPage";
import Loading from "components/shared/Loading";

import { ENABLE_LOGIN_HOME } from "config";
import { setSessionKey, setUserId } from "actions";
import localStorageService from "services/localStorageService";
import sessionStorageService from "services/sessionStorageService";
import loginServices from "services/loginServices";
import localize from "lang/localize";

export const mapStateToProps = (state, ownProps) => {
  return {
    sessionKey: state.sessionKey,
    projectId: state.projectId,
    userId: state.user ? state.user.id : null,
    language: state.language
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setSessionKey: sessionKey => {
      dispatch(setSessionKey(sessionKey));
    },
    setUserId: user => {
      dispatch(setUserId(user));
    }
  };
};

export class SSOLoginSuccessContainer extends Component {
  constructor() {
    super();
    this.state = {
      sessionKey: null,
      userId: null
    };
  }

  componentDidMount() {
    let parametersString = this.props.id;

    /* Route out if there is already an existing sessionKey and userId */
    if (this.props.sessionKey && this.props.userId) {
      loginServices.postLoginReplaceAndNavigate(
        this.props.projectId,
        null,
        false
      );
    } else {
      if (
        this.props.id &&
        typeof this.props.id === "string" &&
        this.props.id.indexOf("/?") === 0
      ) {
        this.setParameters(parametersString, 2);
      } else if (
        this.props.id &&
        typeof this.props.id === "string" &&
        this.props.id.indexOf("?") === 0
      ) {
        this.setParameters(parametersString, 1);
      } else {
        this.setState({
          sessionKey: false,
          userId: false
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.sessionKey !== this.state.sessionKey ||
      prevState.userId !== this.state.userId
    ) {
      if (
        typeof this.state.sessionKey === "string" &&
        typeof this.state.userId === "number"
      ) {
        this.handleLogin();
      }
    }
  }

  handleLogin() {
    localStorageService.saveState({
      user_id: this.state.userId,
      sessionKey: this.state.sessionKey
    });
    this.props.setUserId(this.state.userId);
    this.props.setSessionKey(this.state.sessionKey);

    // loads loginRedirectUrl from sessionStorage (if available)
    // eventually loginRedirectUrl will be dumped when new page is loaded
    // (not REGISTER nor LOGIN nor RESET_PASSWORD)
    // for the aforementioned dumping, see SingleProjectApp.js
    let loginRedirectUrl = sessionStorageService.getItem("loginRedirectUrl");

    loginServices.postLoginReplaceAndNavigate(
      this.props.projectId,
      loginRedirectUrl,
      false
    );
  }

  setParameters(slicedUrl, index) {
    const PARAMETERS = this.renderParametersInArray(slicedUrl, index);

    PARAMETERS.forEach(this.setSessionKeyAndUserId);
  }

  setSessionKeyAndUserId = (item, index) => {
    /*
      set session key and user id to false,
      before reverifying by checking parameters
    */
    this.setState(
      {
        userId: false,
        sessionKey: false
      },
      () => {
        if (item.indexOf("sessionKey=") === 0) {
          this.setState({
            sessionKey: item.slice(11)
          });
        } else if (item.indexOf("userId=") === 0) {
          this.setState({
            userId: isNaN(parseInt(item.slice(7), 10))
              ? false
              : parseInt(item.slice(7), 10)
          });
        }
      }
    );
  };

  renderParametersInArray(slicedUrl, index) {
    return slicedUrl.slice(index).split("&");
  }

  getLoginRoute() {
    if (this.props.projectId && ENABLE_LOGIN_HOME) {
      return PROJECT_LOGIN_HOME.format(this.props.projectId);
    } else if (this.props.projectId) {
      return PROJECT_LOGIN.format(this.props.projectId);
    } else if (ENABLE_LOGIN_HOME) {
      return LOGIN_HOME;
    } else {
      return LOGIN;
    }
  }

  render() {
    /*
      When sessionKey and userId are not yet set, they will be null.
      When sessionKey and userId are WRONGFULLY set, they will be false.
    */
    if (this.state.sessionKey === false || this.state.userId === false) {
      return (
        <GenericErrorPage
          routeUrl={this.getLoginRoute()}
          routeName={localize("nav_bar_title_login_text", this.props.language)}
          message={localize("login_failed_text", this.props.language)}
          language={this.props.language}
        />
      );
    } else {
      return <Loading />;
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SSOLoginSuccessContainer);
